<template>
  <v-dialog
    v-model="visible"
    width="50%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
    content-class="elevation-0"
  >
    <v-card class="pa-0 ma-0 rounded-xl">
      <v-card-title>
        {{ selectedKontakte.length }} {{ bezMitglieder }} bearbeiten
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

      <v-card-text class="pb-0">
        <v-row no-gutters>
          <v-col>
            <v-alert type="info"
              >Diese Funktion ist bisher noch nicht für verschiedene Vereine optimiert. Daher kann sie nur für Ripuaria
              verwendet werden.</v-alert
            >
          </v-col>
          <v-col cols="12">
            Sollen alle Kontakte oder nur die ausgeählten Kontakte bearbeitet werden?
            <v-radio-group v-model="bearbeiteteFelder.alleBearbeiten">
              <v-radio
                label="Alle Bearbeiten"
                value="true"
                on-icon="radio_button_checked"
                off-icon="radio_button_unchecked"
              ></v-radio>
              <v-radio
                label="Ausgewählte Bearbeiten"
                value="false"
                on-icon="radio_button_checked"
                off-icon="radio_button_unchecked"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="mt-2">
        <v-row no-gutters>
          <v-col cols="6" class="px-1">
            <v-select outlined dense :items="itemsAnrede" label="Anrede" v-model="bearbeiteteFelder.anrede"></v-select>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-select
              outlined
              dense
              :items="itemsBriefanrede"
              label="Briefanrede"
              v-model="bearbeiteteFelder.briefanrede"
            ></v-select>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-autocomplete
              outlined
              dense
              :items="selectVerbindung"
              label="Urverbindung"
              v-model="bearbeiteteFelder.urverbindung"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-select
              hide-details="auto"
              clearable
              dense
              outlined
              class="feld"
              :items="itemsZirkel"
              label="AH-Zirkel"
              v-model="bearbeiteteFelder.zirkel"
            ></v-select>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-select outlined dense :items="itemsStatus" label="Status" v-model="bearbeiteteFelder.status"></v-select>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              outlined
              dense
              label="Aktiven-Beitrag"
              v-model="bearbeiteteFelder.aktivenBeitrag"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field outlined dense label="CV-Beitrag" v-model="bearbeiteteFelder.cvBeitrag"></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field outlined dense label="AHV-Beitrag" v-model="bearbeiteteFelder.ahvBeitrag"></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field outlined dense label="HBV-Beitrag" v-model="bearbeiteteFelder.hbvBeitrag"></v-text-field>
          </v-col>
          <v-col cols="12" class="px-1">
            <v-card outlined>
              <v-card-title class="ma-0 pa-2">
                SEPA Berechtigungen ändern?
                <v-spacer></v-spacer>
                <v-switch outlined v-model="bearbeiteteFelder.sepa_bearbeiten"> </v-switch>
              </v-card-title>
              <v-divider v-if="bearbeiteteFelder.sepa_bearbeiten"></v-divider>
              <v-card-text v-if="bearbeiteteFelder.sepa_bearbeiten">
                <v-switch
                  v-for="(item, index) in kassen"
                  :key="index"
                  outlined
                  :label="item.name"
                  v-model="bearbeiteteFelder.sepa[item.name]"
                >
                </v-switch>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="close()">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="updateData()" class="primary">Speichern</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="showUpdate"
      width="40%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
      content-class="elevation-0"
    >
      <v-card class="pa-0 ma-0 rounded-xl">
        <v-card-title> Kontakte updaten </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-progress-linear stream rounded height="24" :value="(updatedItems / allItems) * 100">
            {{ updatedItems }} von {{ allItems }}
          </v-progress-linear>
          <v-alert type="warning" v-if="error.length > 0">
            {{ error }}
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showUpdate = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  export default {
    props: ["visible", "selectedKontakte"],
    data() {
      return {
        loading: false,
        showUpdate: false,
        updatedItems: 0,
        allItems: 0,
        error: [],
        itemsBriefanrede: [
          "Lieber Bundesbruder",
          "Sehr geehrter Cartellbruder",
          "Sehr geehrter Farbenbruder",
          "Sehr geehrter Herr",
          "Sehr geehrte Frau",
          "Sehr geehrte Damen und Herren",
        ],
        itemsAnrede: ["Herr", "Frau", "Familie"],
        selectVerbindung: [
          "V.K.Th. Burgundia im Albertinum",
          "AV Alania Stuttgart",
          "AV Alsatia Münster",
          "AV Cheruscia Münster",
          "AV Cheruskia Tübingen",
          "AV Frisia Hannover",
          "AV Glückauf-Salia Clausthal-Zellerfeld",
          "AV Guestfalia Tübingen",
          "AV Hansea (Berlin) Köln",
          "AV Palatia Göttingen",
          "AV Rheinstein Köln",
          "AV Rheno-Guestfalia Kiel",
          "AV Salia-Silesia Gleiwitz",
          "AV Silesia (Halle, Bonn) Bochum",
          "AV Sparrenberg Bielefeld",
          "AV Suebo-Danubia Ulm",
          "AV Tuisconia (Königsberg, Bonn) Landshut",
          "AV Widukind Osnabrück",
          "AV Zollern Münster",
          "CV-Verbindung Rheno-Palatia (Breslau) Mainz",
          "FAV Rheno-Guestfalia (Hann. Münden) Göttingen",
          "KAV Capitolina Rom",
          "KAV Suevia Berlin",
          "KDStV Adolphiana Fulda",
          "KDStV Aenania München",
          "KDStV Agilolfia Freising",
          "KDStV Alania Bonn",
          "KDStV Alcimonia Eichstätt",
          "KDStV Alemannia Greifswald und Münster",
          "KDStV Algovia Augsburg",
          "KDStV Angrivaria (Sarstedt, Hannover) Dortmund",
          "KDStV Arminia Freiburg im Breisgau",
          "KDStV Arminia Heidelberg",
          "KDStV Ascania Bonn",
          "KDStV Asgard (Düsseldorf) Köln",
          "KDStV Aureo-Danubia Ingolstadt",
          "KDStV Badenia (Straßburg) Frankfurt am Main",
          "KDStV Baltia (Danzig) Aachen",
          "KDStV Bavaria Berlin",
          "KDStV Bavaria Bonn",
          "KDStV Bergisch-Thuringia Wuppertal",
          "KDStV Bergland (Freiberg) Aachen",
          "KDStV Bodensee Konstanz",
          "KDStV Borusso-Saxonia Berlin",
          "KDStV Borusso-Westfalia Bonn",
          "KDStV Burgundia (Leipzig) Düsseldorf",
          "KDStV Burgundia München",
          "KDStV Carolingia Hohenheim",
          "KDStV Carolus Magnus Saarbrücken",
          "KDStV Cheruscia Würzburg",
          "KDStV Churpfalz Mannheim",
          "KDStV Chursachsen Dresden",
          "KDStV Churtrier Trier",
          "KDStV Elbmark (Tetschen-Liebwerd) Duisburg",
          "KDStV Falkenstein Freiburg im Breisgau",
          "KDStV Ferdinandea (Prag) Heidelberg",
          "KDStV Franco-Raetia Würzburg",
          "KDStV Franconia Aachen",
          "KDStV Frankonia (Czernowitz) Erlangen",
          "KDStV Fredericia Bamberg",
          "KDStV Germania Leipzig",
          "KDStV Gothia Erlangen",
          "KDStV Gothia Würzburg",
          "KDStV Greiffenstein (Breslau) Frankfurt",
          "KDStV Guestfalo-Silesia Paderborn",
          "KDStV Hasso-Nassovia Frankfurt am Main",
          "KDStV Hercynia Freiburg im Breisgau",
          "KDStV Hohenstaufen Freiburg im Breisgau",
          "KDStV Kaiserpfalz Aachen",
          "KDStV Langobardia (München) Bayreuth",
          "KDStV Makaria (Berlin) Aachen",
          "KDStV Marchia (Breslau) Aachen",
          "KDStV Markomannia Würzburg",
          "KDStV Merowingia Kaiserslautern",
          "KDStV Moenania München",
          "KDStV Moeno-Franconia Frankfurt am Main",
          "KDStV Nassovia Darmstadt",
          "KDStV Nibelungia (Brünn) Darmstadt",
          "KDStV Niedersachsen Braunschweig",
          "KDStV Norbertina Magdeburg",
          "KDStV Nordgau (Prag, Stuttgart) Koblenz",
          "KDStV Nordmark (Rostock, Karlsruhe) Essen",
          "KDStV Normannia Karlsruhe",
          "KDStV Novesia Bonn",
          "KDStV Oeno-Danubia Passau",
          "KDStV Ostmark Nürnberg",
          "KDStV Palatia Marburg",
          "KDStV Palatina Amberg/Weiden",
          "KDStV Radaspona (Regensburg) München",
          "KDStV Rappoltstein (Straßburg) Köln",
          "KDStV Rheinland Köln",
          "KDStV Rheinpfalz Darmstadt",
          "KDStV Rhenania-Moguntia Mainz",
          "KDStV Rheno-Baltia Köln",
          "KDStV Rheno-Franconia München",
          "KDStV Rheno-Saxonia (Köthen) Halle",
          "KDStV Ripuaria Aachen",
          "KDStV Ripuaria Bonn",
          "KDStV Ripuaria Freiburg im Breisgau",
          "KDStV Rupertia Regensburg",
          "KDStV Saarland (Saarbrücken) Jena",
          "KDStV Sauerlandia Münster",
          "KDStV Saxo-Silesia Hannover",
          "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum",
          "KDStV Schwarzwald Karlsruhe",
          "KDStV Seraphina Lippstadt",
          "KDStV Staufia Bonn",
          "KDStV Sugambria (Jena) Göttingen",
          "KDStV Teuto-Rhenania Hannover",
          "KDStV Teutonia Freiburg im Üechtland",
          "KDStV Thuringia Würzburg",
          "KDStV Trifels München",
          "KDStV Tuiskonia München",
          "KDStV Vandalia (Prag) München",
          "KDStV Vasgovia Landau",
          "KDStV Vindelicia München",
          "KDStV Welfia Weingarten",
          "KDStV Wiking Hamburg",
          "KDStV Wildenstein Freiburg im Breisgau",
          "KDStV Winfridia (Breslau) Münster",
          "KStV Thuringia Coburg",
          "KTV Visurgis Bremen",
          "VKDSt Hasso-Rhenania Gießen",
          "VKDSt Hasso-Rhenania Mainz",
          "VKDSt Rhenania Marburg",
          "VKDSt Saxonia Münster",
        ],
        itemsZirkel: [
          "Aachen",
          "Berlin",
          "Bonn/Köln",
          "Düsseldorf/Neuss",
          "Essen",
          "Koblenz",
          "München",
          "Niederrhein",
        ],
        bearbeiteteFelder: {
          sepa: {},
        },
      };
    },
    computed: {
      kontakte() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      bezMitglieder() {
        return this.$store.getters["einstellungen/einstellung"]("allgemein").bezMitglieder;
      },
      kassen() {
        return this.$store.state.einstellungen.einstellungen.find((item) => item.id === "kassen");
      },
      itemsStatus() {
        let status = [];
        this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach((item) => {
          status.push(item.status);
        });
        return status;
      },
    },
    methods: {
      updateData() {
        this.showUpdate = true;
        var functions = this.$firebase.functions();
        var items = [];
        if (this.bearbeiteteFelder.alleBearbeiten === "true") {
          this.kontakte.forEach((kontakt) => {
            items.push(kontakt.id);
          });
        } else {
          items = this.selectedKontakte;
        }
        this.updatedItems = 0;
        this.allItems = items.length;
        items.forEach((id) => {
          let bbr = this.$store.getters["bbrbbr/bbr"](id);
          if (this.bearbeiteteFelder.anrede) {
            bbr.anrede = this.bearbeiteteFelder.anrede;
          }
          if (this.bearbeiteteFelder.briefanrede) {
            bbr.briefanrede = this.bearbeiteteFelder.briefanrede;
          }
          if (this.bearbeiteteFelder.urverbindung) {
            bbr.urverbindung = this.bearbeiteteFelder.urverbindung;
          }
          if (this.bearbeiteteFelder.zirkel) {
            bbr.zirkel = this.bearbeiteteFelder.zirkel;
          }
          if (this.bearbeiteteFelder.status) {
            bbr.status = this.bearbeiteteFelder.status;
          }
          if (this.bearbeiteteFelder.aktivenBeitrag) {
            bbr.aktivenBeitrag = this.bearbeiteteFelder.aktivenBeitrag;
          }
          if (this.bearbeiteteFelder.cvBeitrag) {
            bbr.cvBeitrag = this.bearbeiteteFelder.cvBeitrag;
          }
          if (this.bearbeiteteFelder.ahvBeitrag) {
            bbr.ahvBeitrag = this.bearbeiteteFelder.ahvBeitrag;
          }
          if (this.bearbeiteteFelder.hbvBeitrag) {
            bbr.hbvBeitrag = this.bearbeiteteFelder.hbvBeitrag;
          }
          if (this.bearbeiteteFelder.sepa_bearbeiten) {
            if (bbr.sepa === undefined) {
              bbr.sepa = {};
            }
            Object.keys(this.bearbeiteteFelder.sepa).forEach((key) => {
              if (this.bearbeiteteFelder.sepa[key] !== null) {
                bbr.sepa[key] = this.bearbeiteteFelder.sepa[key];
              }
            });
          }
          functions
            .httpsCallable("updateUser")({ user: bbr, verein: this.$vars.verbindung })
            .then((result) => {
              if (result.data.status) {
                this.updatedItems++;
                if (this.updatedItems === this.allItems) {
                  this.showUpdate = false;
                  this.close();
                }
              } else {
                this.error.push(result.data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        });
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// dialogKontaktEditMultiple.vue?77d74d20